import axios from "axios";
import { getConfig } from '../helpers/config'

export class UserService {
	baseAPIUrl = `${getConfig()?.url}utenti`;

	getUserRoles = async (userInfo) => {
		return await axios.post(`${this.baseAPIUrl}/ruoli`, { userInfo })
											.then(res => res.data);
	}

	getById = async (id) => {
		return await axios.get(`${this.baseAPIUrl}/${id}`)
											.then(res => res.data);
	}

	getByFiscalCode = async (fiscalCode) => {
		return await axios.get(`${this.baseAPIUrl}/codiceFiscale/${fiscalCode}`)
											.then(res => res.data);
	}

	getDatiUtente = async () => {
		return await axios.get(`${this.baseAPIUrl}/utente/datiUtenti`)
											.then(res => res.data);
	}

	getByFiscalCodePerAssociazione = async (fiscalCode) => {
		return await axios.get(`${this.baseAPIUrl}/associazione/codiceFiscale/${fiscalCode}`)
											.then(res => res.data);
	}

	getAllDt = async (data) => {
		return await axios.post(`${this.baseAPIUrl}/dt`, data)
											.then(res => res.data);
	}

	create = async (data) => {
		return await axios.post(`${this.baseAPIUrl}/`, data)
											.then(res => res.data);
	}

	update = async (data) => {
		return await axios.put(`${this.baseAPIUrl}/`, data)
											.then(res => res.data);
	}

	setPresaVisione = async () => {
		return await axios.post(`${this.baseAPIUrl}/presaVisione`)
											.then(res => res.data);
	}

	saveDatiUtente = async (data) => {
		return await axios.post(`${this.baseAPIUrl}/datiUtente`, data)
											.then(res => res.data);
	}
}
